export class UpdateWorkspaceMetricsSettingsInput {
    'deliveryRoleArn';
    'cloudwatchEnabled';
    'cloudwatchMetricNamespace';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "deliveryRoleArn",
            "baseName": "deliveryRoleArn",
            "type": "string",
            "format": ""
        },
        {
            "name": "cloudwatchEnabled",
            "baseName": "cloudwatchEnabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "cloudwatchMetricNamespace",
            "baseName": "cloudwatchMetricNamespace",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateWorkspaceMetricsSettingsInput.attributeTypeMap;
    }
    constructor() {
    }
}
